module.exports = __webpack_public_path__ + "static/media/CheckIcon.d05bdab1.svg";